// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { toHashableBallot, toHashableMultiBallot, hashBallot, hashMultiBallot, encryptBallotSelection, encryptMultiBallotSelection, interpretContestSelection, interpretMultiContestSelection, getWriteInAvailableCharacters, decodeAuditableBallot, decodeAuditableMultiBallot, checkIsBlank, } from "@sequentech/ui-core";
export var provideBallotService = function () { return ({
    toHashableBallot: toHashableBallot,
    toHashableMultiBallot: toHashableMultiBallot,
    hashBallot: hashBallot,
    hashMultiBallot: hashMultiBallot,
    encryptBallotSelection: encryptBallotSelection,
    encryptMultiBallotSelection: encryptMultiBallotSelection,
    interpretContestSelection: interpretContestSelection,
    interpretMultiContestSelection: interpretMultiContestSelection,
    getWriteInAvailableCharacters: getWriteInAvailableCharacters,
    decodeAuditableBallot: decodeAuditableBallot,
    decodeAuditableMultiBallot: decodeAuditableMultiBallot,
    checkIsBlank: checkIsBlank,
}); };
